import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function ChangePassword() {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ current: "", next: "", again: "" });
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    if (f.next !== f.again) { toast.error("The two new passwords are not the same"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password changed. Use the new one next time you log in.");
      setOpen(false); setF({ current: "", next: "", again: "" });
    } catch (err) { toast.error(formatError(err.response?.data?.detail) || err.message); } finally { setBusy(false); }
  };
  const input = (k, label, testId) => (
    <label className="block text-sm font-semibold">{label}
      <input type="password" required value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={testId}
        className="mt-1 w-full rounded-xl border-2 border-slate-200 px-3 py-2 font-normal" autoComplete={k === "current" ? "current-password" : "new-password"} />
    </label>
  );
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="admin-change-password" className="rounded-full border-2 border-slate-600 px-4 py-2 text-sm flex items-center gap-2 hover:bg-slate-800"><KeyRound size={15} /> Password</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="change-password-dialog">
          <DialogHeader><DialogTitle>Change my password</DialogTitle></DialogHeader>
          <form onSubmit={save} className="space-y-3">
            {input("current", "Current password", "change-password-current")}
            {input("next", "New password (at least 8 characters)", "change-password-new")}
            {input("again", "New password again", "change-password-again")}
            <button type="submit" disabled={busy} data-testid="change-password-save" className="w-full rounded-full bg-slate-900 text-white font-bold py-2.5 disabled:opacity-60">
              {busy ? <Loader2 size={16} className="animate-spin mx-auto" /> : "Save new password"}
            </button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
